// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «SLA» (SLA, ключ `sla`, група `settings`). */
export const slaManifest: IModuleManifest = {
  key: 'sla',
  group: 'settings',
  slug: 'sla',
  prefix: 'SLA',
  name: { en: 'SLA', uk: 'SLA' },
  entities: [
    { key: 'sla', slug: 'sla', name: { en: 'SLA policies', uk: 'Політики SLA' }, main: true },
    { key: 'slabr', slug: 'slabr', name: { en: 'SLA breaches', uk: 'Порушення SLA' }, main: false },
  ],
  loadState: () => import('./state/slaSlice').then((m) => m.slaSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
